// extracted by mini-css-extract-plugin
export default {"outer":"GalleryCard_outer__IjDOY"};